export default "__VITE_ASSET__d898d5c0__"